import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { ff, form } from "@mc/mc-legacy";
const { Form, FormBody, FormActions } = form;
/**
 * Formulář pro tvorbu / úpravu List.
 */

class ListForm extends React.Component {
  static formName = "ListForm";

  render() {
    const { onClose, submitting, handleSubmit } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <FormBody>
          <ff.String required label="Hlavička" name="head" disabled={submitting} />
          <ff.Textarea rows={20} required label="Tělo mailu" name="body" disabled={submitting} />
        </FormBody>
        <FormActions onClose={onClose} storeButton cancelButton disabled={submitting} />
      </Form>
    );
  }
}

export default connect()(
  reduxForm({
    form: ListForm.formName,
  })(ListForm)
);
